import configuration from "@/configuration";

const LoadingView = () => {
    return (
        <div className="flex flex-col fixed top-0 left-0 right-0 bottom-0 h-full w-full items-center justify-center select-none">
            <img
                src={`${configuration.assets}content/logo-bimids.png`}
                alt="Logo BIMids"
                className="h-[100px] w-auto"
            />
            <div className="font-medium text-lg mt-8">Administration Portal</div>
            <div className="flex space-x-2 mt-20">
                <div className="w-5 h-5 bg-primary-500 rounded-full animate-loader"></div>
                <div className="w-5 h-5 bg-primary-500 rounded-full animate-loader [animation-delay:.15s]"></div>
                <div className="w-5 h-5 bg-primary-500 rounded-full animate-loader [animation-delay:.30s]"></div>
                <div className="w-5 h-5 bg-primary-500 rounded-full animate-loader [animation-delay:.45s]"></div>
            </div>
        </div>
    );
};

export default LoadingView;
